export enum PackagingFilterEnum {
  STANDARD = "STANDARD",
  WOODBOX = "WOODBOX",
  CUSTOM_SINGLE = "CUSTOM_SINGLE",
  CUSTOM_MULTIPLE = "CUSTOM_MULTIPLE",
  CUSTOM_PALETTE = "CUSTOM_PALETTE",
  CUSTOM_PARCEL = "CUSTOM_PARCEL",
}
